import { render, staticRenderFns } from "./ProductTypeAttributesList.component.vue?vue&type=template&id=cc879d86&scoped=true&"
import script from "./ProductTypeAttributesList.component.vue?vue&type=script&lang=js&"
export * from "./ProductTypeAttributesList.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc879d86",
  null
  
)

export default component.exports